export default [
    {
      path: '/admin-branch/customer',
      name: 'admin-branch-customer',
      component: () => import('@/views/admin-branch/Customer/customer.vue'),
      meta: {
        pageTitle: 'ข้อมูลลูกค้า',
        breadcrumb: [
          {
            text: 'ข้อมูลลูกค้า',
            active: true,
          },
        ],
        resource: 'BranchAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin-branch/customer-balance',
      name: 'admin-branch-customer-balance',
      component: () => import('@/views/admin-branch/Customer/balance.vue'),
      meta: {
        pageTitle: 'รายการ Balance',
        breadcrumb: [
          {
            text: 'รายการ Balance',
            active: true,
          },
        ],
        resource: 'BranchAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin-branch/check-payment',
      name: 'admin-branch-check-payment',
      component: () => import('@/views/admin-branch/payment/check-payment.vue'),
      meta: {
        pageTitle: 'ตรวจสอบแจ้งชำระเงิน',
        breadcrumb: [
          {
            text: 'ตรวจสอบแจ้งชำระเงิน',
            active: true,
          },
        ],
        resource: 'BranchAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin-branch/order-status',
      name: 'admin-branch-order-status',
      component: () => import('@/views/admin-branch/admin/order-status.vue'),
      meta: {
        pageTitle: 'สถานะใบสั่งซื้อ',
        breadcrumb: [
          {
            text: 'สถานะใบสั่งซื้อ',
            active: true,
          },
        ],
        resource: 'BranchAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin-branch/order-detail',
      name: 'admin-branch-order-detail',
      component: () => import('@/views/admin-branch/admin/order-detail.vue'),
      meta: {
        pageTitle: 'รายละเอียดออเดอร์',
        contentClass: 'ecommerce-application',
        breadcrumb: [
          {
            text: 'สถานะใบสั่งซื้อ',
            active: false,
            to: '/admin-branch/order-status',
          },
          {
            text: 'รายละเอียดออเดอร์',
            active: true,
          },
        ],
        resource: 'BranchAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin-branch/setting',
      name: 'admin-branch-admin-setting',
      component: () => import('@/views/admin-branch/admin/setting.vue'),
      meta: {
        pageTitle: 'ตั้งค่าผู้ดูแลระบบ',
        breadcrumb: [
          {
            text: 'ตั้งค่าผู้ดูแลระบบ',
            active: true,
          },
        ],
        resource: 'BranchAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin-branch/shipping-rate-standard',
      name: 'admin-branch-shipping-rate-standard',
      component: () => import('@/views/admin-branch/shipping-rate/standard-rate.vue'),
      meta: {
        pageTitle: 'ตั้งค่านำเข้ามาตรฐาน',
        breadcrumb: [
          {
            text: 'ตั้งค่านำเข้ามาตรฐาน',
            active: true,
          },
        ],
        resource: 'BranchAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin-branch/shipping-rate-customer',
      name: 'admin-branch-shipping-rate-customer',
      component: () => import('@/views/admin-branch/shipping-rate/customer-rate.vue'),
      meta: {
        pageTitle: 'ตั้งค่านำเข้ารายลูกค้า',
        breadcrumb: [
          {
            text: 'ตั้งค่านำเข้ารายลูกค้า',
            active: true,
          },
        ],
        resource: 'BranchAdmin',
        action: 'manage',
      },
    },
  ]
